export default __webpack_public_path__ + "static/media/P1000.f47f041a.svg";